import { IAction, KEEP_THE_SAME, StateStatus } from 'redux/utils/common';
import * as Types from './type';
import * as ProductService from 'services/api/product';
import { LanguagesEnum } from 'constants/languages';
import { ISpecificationAttributeListOutput } from 'services/api/specificationattribute';
import { IParalistByGroupData } from 'services/api/paralist';
import { IDataItems } from 'services/api/zones';
import { IAgent, IRole, ICustomersMiniProfileData } from 'services/api/client';
export interface IState {
  segments: {
    data: ProductService.ISegments | null;
    status: StateStatus | null;
  };
  customers: {
    data: Array<ProductService.IMiniProfile>;
    status: StateStatus | null;
  };
  clientCustomers: {
    data: Array<ProductService.IMiniProfile>;
    status: StateStatus | null;
  };
  agents: {
    data: Array<ProductService.IMiniProfile>;
    status: StateStatus | null;
  };
  productBasicInfo: {
    data: ProductService.ProductBasicInfo | null;
    status: StateStatus | null;
  };
  updateBasicInfoStatus: StateStatus | null;
  temporaryDescription: Array<{ language: LanguagesEnum; value: string }>;
  temporaryName: Array<{ language: LanguagesEnum; value: string }>;
  specificationAttributeList: {
    status: StateStatus | null;
    data: ISpecificationAttributeListOutput | null;
  };
  specificationAttributeListNoAmentities: {
    status: StateStatus | null;
    data: ISpecificationAttributeListOutput | null;
  };
  priceTypeList: {
    status: StateStatus | null;
    data: IParalistByGroupData | null;
  };
  zoneList: {
    status: StateStatus | null;
    data: IDataItems[] | null;
  };
  roles: {
    status: StateStatus | null;
    data: Array<IRole>;
  };
  addCustomerStatus: StateStatus | null;
  clientMiniProfiles: {
    status: StateStatus | null;
    data: ICustomersMiniProfileData | null;
  };
  agentsCustomer: {
    status: StateStatus | null;
    data: Array<IAgent>;
  };
}

const initialState: IState = {
  segments: {
    data: null,
    status: null,
  },
  customers: {
    data: [],
    status: null,
  },
  clientCustomers: {
    data: [],
    status: null,
  },
  agents: {
    data: [],
    status: null,
  },
  productBasicInfo: {
    data: null,
    status: null,
  },
  updateBasicInfoStatus: null,
  temporaryDescription: [],
  temporaryName: [],
  specificationAttributeList: {
    status: null,
    data: null,
  },
  specificationAttributeListNoAmentities: {
    status: null,
    data: null,
  },
  priceTypeList: {
    status: null,
    data: null,
  },
  zoneList: {
    status: null,
    data: null,
  },
  roles: {
    status: null,
    data: [],
  },
  addCustomerStatus: null,
  clientMiniProfiles: {
    status: null,
    data: null,
  },
  agentsCustomer: {
    status: null,
    data: [],
  },
};

const ProductReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_SEGMENTS:
      return {
        ...state,
        segments: {
          ...state.segments,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_CUSTOMERS:
      return {
        ...state,
        customers: {
          ...state.customers,
          status: action.status || null,
          data: action.data,
        },
      };

    case Types.SET_CLIENT_CUSTOMERS:
      return {
        ...state,
        clientCustomers: {
          ...state.clientCustomers,
          status: action.status || null,
          data: action.data,
        },
      };

    case Types.SET_AGENTS:
      return {
        ...state,
        agents: {
          ...state.agents,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_PRODUCT_BASIC_INCO:
      return {
        ...state,
        productBasicInfo: {
          ...state.productBasicInfo,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.UPDATE_PRODUCT_BASIC_INFO:
      return {
        ...state,
        updateBasicInfoStatus: action.status || null,
      };
    case Types.UPDATE_DESCRIPTION_TEMPORARY:
      return {
        ...state,
        temporaryDescription: action.data,
      };

    case Types.UPDATE_NAME_TEMPORARY:
      return {
        ...state,
        temporaryName: action.data,
      };
    case Types.SET_SPECIFICATIONATTRIBUTE_LIST:
      return {
        ...state,
        specificationAttributeList: {
          ...state.specificationAttributeList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.specificationAttributeList.data
              : action.data,
        },
      };
    case Types.SET_SPECIFICATIONATTRIBUTE_LIST_NO_AMENTITIES:
      return {
        ...state,
        specificationAttributeListNoAmentities: {
          ...state.specificationAttributeListNoAmentities,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.specificationAttributeListNoAmentities.data
              : action.data,
        },
      };
    case Types.GET_LIST_PRICE_TYPE:
      return {
        ...state,
        priceTypeList: {
          ...state.priceTypeList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.priceTypeList.data
              : action.data,
        },
      };
    case Types.GET_LIST_ZONES:
      return {
        ...state,
        zoneList: {
          ...state.zoneList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME ? state.zoneList.data : action.data,
        },
      };
    case Types.SET_AGENTS_CUSTOMER:
      return {
        ...state,
        agentsCustomer: {
          ...state.agentsCustomer,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.FETCH_ROLES:
      return {
        ...state,
        roles: {
          ...state.roles,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_CLIENTS_MINI_PROFILES:
      return {
        ...state,
        clientMiniProfiles: {
          ...state.clientMiniProfiles,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.ADD_CUSTOMER:
      return {
        ...state,
        addCustomerStatus: action.status || null,
      };

    default:
      return {
        ...state,
      };
  }
};

export default ProductReducer;
